import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .photo-upload-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .current-photo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .photo-preview {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 8px;
    border: 2px solid var(--sl-color-neutral-200);
  }

  .upload-area {
    border: 2px dashed var(--sl-color-neutral-300);
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background: var(--sl-color-neutral-50);
  }

  .upload-area:hover {
    border-color: var(--sl-color-primary-400);
    background: var(--sl-color-primary-50);
  }

  .upload-area.drag-over {
    border-color: var(--sl-color-primary-600);
    background: var(--sl-color-primary-100);
  }

  .upload-area.uploading {
    border-color: var(--sl-color-primary-600);
    background: var(--sl-color-primary-50);
    cursor: not-allowed;
  }

  .upload-icon {
    font-size: 2rem;
    color: var(--sl-color-neutral-400);
    margin-bottom: 0.5rem;
  }

  .upload-text {
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .upload-hint {
    color: var(--sl-color-neutral-500);
    font-size: 0.75rem;
  }

  .file-input {
    display: none;
  }

  .upload-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
  }

  .error-message {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: 6px;
    color: var(--sl-color-danger-700);
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }

  .error-message sl-icon {
    margin-right: 0.5rem;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .loading sl-spinner {
    margin-right: 0.5rem;
  }
`;
